import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import get from 'lodash.get';

import AIMS_FLAVORS from 'lib/aimsFlavors';
import { content as ContentPropType } from 'lib/CustomPropTypes';
import { parseDate } from 'lib/DateTime';
import { getTeaseUrl } from 'lib/teaseUtils';

import { Byline } from 'components/Byline';
import Link from 'components/Link';
import Picture from 'components/Picture';
import Unibrow from 'components/Unibrow';

import { appendTracking, appendTrackingUnibrow } from '../../utility';
import styles from './styles.module.scss';

function Featured(props) {
  const {
    item,
    showFeaturePublishedDate,
  } = props;

  const imageURL = getTeaseUrl(item, false);
  const authors = get(item, ['item', 'authors'], []);
  const date = parseDate(get(item, ['item', 'datePublished']), null);

  // Display last two digits of year
  let { year } = date;
  if (year && typeof year === 'number' && year > 2000) {
    year = year.toString().substr(-2);
  }

  // Computed
  const headline = get(item, ['computedValues', 'headline']);
  let unibrow = get(item, ['computedValues', 'unibrow']);
  let url = get(item, ['computedValues', 'url']);

  // Append tracking to content and unibrow links
  const trackingType = 'pkgArticle';
  url = appendTracking(url, trackingType);
  unibrow = appendTrackingUnibrow(unibrow, trackingType);

  return (
    <div className={styles.featuredArticle} data-contentid={item.id}>
      {imageURL && (
        <div className={styles.picture}>
          <Link to={url}>
            <Picture
              responsiveFlavors={{
                s: AIMS_FLAVORS.FOCAL_758x379,
                m: AIMS_FLAVORS.FOCAL_320x160,
                l: AIMS_FLAVORS.FOCAL_200x100,
              }}
              url={imageURL}
            />
          </Link>
        </div>
      )}
      <div className={styles.info}>
        <Unibrow
          className={classNames(styles.unibrow, { [styles.withDate]: showFeaturePublishedDate })}
          size="h4"
          unibrow={unibrow}
        />
        <h3 className={styles.headline}>
          <Link to={url}>
            {showFeaturePublishedDate && (
              <span className={styles.date}>
                {date.month}
                .
                {date.day}
                .
                {year}
                {' / '}
              </span>
            )}
            {headline}
          </Link>
        </h3>
        {Array.isArray(authors) && authors.length > 0 && (
          <div className={styles.author}>
            <Byline authors={authors} />
          </div>
        )}
      </div>
    </div>
  );
}

Featured.propTypes = {
  item: ContentPropType.isRequired,
  showFeaturePublishedDate: PropTypes.bool,
};

Featured.defaultProps = {
  showFeaturePublishedDate: false,
};

export { Featured };
